// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars___wyN4","legalNotice":"styles_legalNotice__qKHx5","lightMode":"styles_lightMode__0X2j9","slideInSearchBar":"styles_slideInSearchBar__UyfOi"};